// Mock data for Ruonn website clone

export const partners = [
  { id: 1, name: 'Amsterdam', logo: 'amsterdam' },
  { id: 2, name: 'SAVANNAH', logo: 'savannah' },
  { id: 3, name: 'luminous', logo: 'luminous' },
  { id: 4, name: 'Theo', logo: 'theo' },
  { id: 5, name: 'Amsterdam', logo: 'amsterdam' },
  { id: 6, name: 'SAVANNAH', logo: 'savannah' },
  { id: 7, name: 'luminous', logo: 'luminous' },
  { id: 8, name: 'Theo', logo: 'theo' },
];

export const stats = [
  { id: 1, value: '500+', label: 'Engineers Placed' },
  { id: 2, value: '98%', label: 'Client Satisfaction' },
  { id: 3, value: '72hrs', label: 'Average Match Time' },
  { id: 4, value: '100%', label: 'Replacement Guarantee' },
];

export const howItWorksSteps = [
  {
    id: 1,
    number: '1',
    title: 'Book a Call',
    description: 'Our expert will assess your goals, tech needs, and team fit.',
  },
  {
    id: 2,
    number: '2',
    title: 'Meet Your Talent',
    description: "We'll present selected candidates within 72 hours for you to interview.",
  },
  {
    id: 3,
    number: '3',
    title: 'Start Building',
    description: 'Onboard your new team member with our full replacement guarantee if not satisfied.',
  },
];

export const featureItems = [
  { id: 1, text: 'Accelerate Your Growth', completed: false },
  { id: 2, text: 'Build with Confidence', completed: false },
  { id: 3, text: 'Access Specialized Expertise', completed: false },
  { id: 4, text: 'Tech Team in Action', completed: false },
  { id: 5, text: 'Scale with Purpose', completed: false },
];

export const benefits = [
  {
    id: 1,
    title: 'Pre-Vetted Talent',
    description: 'Access top 3% of tech talent, rigorously tested and verified.',
    icon: 'shield',
  },
  {
    id: 2,
    title: 'Replacement Guarantee',
    description: 'Not satisfied? We\'ll find you a replacement at no extra cost.',
    icon: 'zap',
  },
  {
    id: 3,
    title: 'Fast Matching',
    description: 'Get matched with perfect candidates within 72 hours.',
    icon: 'clock',
  },
  {
    id: 4,
    title: 'Flexible Scaling',
    description: 'Scale your team up or down based on project needs.',
    icon: 'trending',
  },
];

export const testimonials = [
  {
    id: 1,
    quote: 'Ruonn completely transformed the way I manage my team day to day.',
    author: 'Charles Lemmond',
    role: 'CEO, TechStart',
    avatar: 'CL',
  },
  {
    id: 2,
    quote: 'We scaled from 5 to 25 developers in just 3 months. Incredible service!',
    author: 'Sarah Mitchell',
    role: 'CTO, InnovateCo',
    avatar: 'SM',
  },
  {
    id: 3,
    quote: 'The quality of developers we got exceeded our expectations.',
    author: 'James Rodriguez',
    role: 'Founder, AppWorks',
    avatar: 'JR',
  },
];

export const faqs = [
  {
    id: 1,
    question: 'Is Ruonn available for all software businesses?',
    answer: 'Yes, Ruonn is designed to cater to software businesses of all sizes, from startups building their first tech team to established companies scaling their software operations.',
  },
  {
    id: 2,
    question: 'How easy is it to get started?',
    answer: 'Getting started is incredibly simple. Just book a call with our team, and we\'ll guide you through the entire process. Within 72 hours, you\'ll have access to pre-vetted candidates.',
  },
  {
    id: 3,
    question: 'What if I\'m not satisfied with my hire?',
    answer: 'We stand behind our talent with a 100% replacement guarantee. If you\'re not completely satisfied with your hire, we\'ll find you a replacement at no additional cost.',
  },
  {
    id: 4,
    question: 'What kind of roles can Ruonn help fill?',
    answer: 'We specialize in tech roles including developers, QA engineers, DevOps specialists, product managers, and other technical positions essential for software businesses.',
  },
  {
    id: 5,
    question: 'How does Ruonn vet candidates?',
    answer: 'Our rigorous vetting process includes technical assessments, background checks, and multiple interview rounds to ensure only top-tier talent is presented to you.',
  },
];

export const saasProducts = [
  {
    id: 1,
    name: 'Lexa.Run',
    image: 'https://framerusercontent.com/images/1wr2AjGFITzk9Z1ZRDsZKnVdFU.png',
    url: 'https://lexa.run/',
  },
];
